import { render, staticRenderFns } from "./AccountStatementList.vue?vue&type=template&id=0b8813d0&scoped=true"
import script from "./AccountStatementList.vue?vue&type=script&lang=js"
export * from "./AccountStatementList.vue?vue&type=script&lang=js"
import style0 from "./AccountStatementList.vue?vue&type=style&index=0&id=0b8813d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8813d0",
  null
  
)

export default component.exports